const content = [
  {
    id: 1,
    title: "Buky Canyon",
    body: "Buky Canyon is a canyon near the Buky village, on the Hirskyi Tikych river in the Cherkasy Oblast (province) of Ukraine. It is approximately 5 km (3.1 mi) long, 20 m (66 ft) deep, and anywhere from 20 to 40 m (66 to 131 ft) wide.",
    image: "canyon.jpeg",
    href: "https://en.wikipedia.org/wiki/Buky_Canyon",
  },
  {
    id: 2,
    title: "Mount Hoverla",
    body: "Mount Hoverla, at 2,061 metres (6,762 ft), is the highest mountain in Ukraine and part of the Carpathian Mountains. The mountain is located in the Eastern Beskids, in the Chornohora region. The slopes are covered with beech and spruce forests, above which there is a belt of sub-alpine meadows called polonyna in Ukrainian.",
    image: "hoverla.jpg",
    href: "https://en.wikipedia.org/wiki/Hoverla",
  },
  {
    id: 3,
    title: "Sofiyivka Park",
    body: "Sofiyivsky Park is an arboretum and a scientific-researching institute of the National Academy of Sciences of Ukraine. The park is located in the northern part of the City of Uman, Cherkasy Oblast. Sofiyivka is a scenic landmark of world gardening design at the beginning of the 19th century.",
    image: "uman.jpg",
    href: "https://en.wikipedia.org/wiki/Sofiyivka_Park",
  },
];

export default content;
